import dayjs from 'dayjs';
import React, { useCallback, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { NavLink, useNavigate } from 'react-router-dom';
import { getQueryDataOnSignClick, openChatBlock } from '../helpers/Chat';
import DateHumanizeHelper from '../helpers/DateHumanizeHelper';
import {
    IsMobile,
    getCommonRoutePath,
    getIndividualNamePath,
    getStudentYear,
    getUniversityId,
    isGlobalVersionTwo,
    isUniGroup,
    showFlag,
} from '../helpers/Helpers';
import isEqualPaths from '../helpers/isEqualPaths';
import { fetchData } from '../redux/actions/randomItems';
import { setSearchTerm } from '../redux/actions/searchActions';

import { Button, Image, List } from 'antd';
import Popover from 'antd/es/popover';
import userDefaultAvatar from '../assets/img/placeholder-user.png';
import universityDefaultAvatar from '../assets/img/university_default_avatar.jpeg';
import { ReactComponent as MessagesIcon } from '../assets/svg/icons/ask-question.svg';
import { IsLoggedIn } from '../helpers/UserHelper';
import { localStorageWrapper, sessionStorageWrapper } from '../helpers/storageFactory';

const TapPageStudentItemV2 = ({
    student,
    searchUsers,
    fromChatToUs,
    university,
    groupUniversityId,
    onChatToMeClick,
    randomPage,
}) => {
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const account = useSelector((state) => state.account);
    const { onlyOneScreen } = useSelector((state) => state.main);
    const filterTerms = useSelector((state) => state.filterTerms);
    const searchTerms = useSelector((state) => state.searchTerms);

    const [showFullText, setShowFullText] = useState(false);

    const isCarousel = window.location.pathname.includes('carousel');

    const handleSearch = useCallback(
        (e, term) => {
            e.stopPropagation();

            const location = window.location;
            const universityId = getUniversityId();
            const uniGroup = isUniGroup();

            if (isCarousel) {
                let query = window.location.href.split('?')[1] ? window.location.href.split('?')[1] : '';
                query = '?' + query;
                return navigate(`${getCommonRoutePath()}/chat-to-us/${student.id}${query}`);
            }

            setSearchTerm(term);

            if (onlyOneScreen) {
                const options = {
                    search: [...searchTerms.items, term.trim(), ...filterTerms.customFilters].filter((term) => term),
                    filterTerms: filterTerms.preparedFilters,
                    groupCountryIds: filterTerms.groupCountryId ? [filterTerms.groupCountryId] : null,
                    random: false,
                };

                searchUsers(options);
            } else if (
                (isEqualPaths(location.pathname, '/' + (uniGroup ? 'group/' + universityId : universityId)) ||
                    window.globalUniversityId ||
                    window.globalGroupId) &&
                !isGlobalVersionTwo
            ) {
                const options = {
                    search: [...searchTerms.items, term.trim(), ...filterTerms.customFilters].filter((term) => term),
                    filterTerms: filterTerms.preparedFilters,
                    groupCountryIds: filterTerms.groupCountryId ? [filterTerms.groupCountryId] : null,
                    random: false,
                };

                dispatch(fetchData(options));

                if ((window.globalUniversityId || window.globalGroupId) && !isGlobalVersionTwo) {
                    navigate({
                        pathname: '/',
                        resetContent: true,
                    });
                }
            } else if (uniGroup && !isGlobalVersionTwo) {
                navigate({
                    pathname: `${getCommonRoutePath()}`,
                    resetContent: true,
                });
            } else {
                const options = {
                    search: [...searchTerms.items, term.trim(), ...filterTerms.customFilters].filter((term) => term),
                    filterTerms: filterTerms.preparedFilters,
                    groupCountryIds: filterTerms.groupCountryId ? [filterTerms.groupCountryId] : null,
                    random: false,
                };

                if (searchUsers) {
                    searchUsers(options);
                }
            }
        },
        // eslint-disable-next-line react-hooks/exhaustive-deps
        [dispatch, student, navigate] // TODO: Bug here, searchUsers is not in the dependencies
    );

    const handleChatToMeClick = useCallback(
        (e, openSignUp) => {
            e.stopPropagation();
            if (e.button === 2) {
                e.preventDefault();
            }
            const isAmbassador =
                account.account_info && account.account_info.id && account.account_info.key === 'univercity-student';
            if (!isAmbassador) {
                sessionStorageWrapper.setItem('goBack', fromChatToUs ? '/chat-to-us' : '');
                localStorageWrapper.setItem(
                    'cameFromData',
                    JSON.stringify({ type: 'profile', from: randomPage ? 'homePage' : 'card' })
                );
                localStorageWrapper.setItem('openedChatData', JSON.stringify({ type: 'profile', from: 'card' }));
            } else {
                e.preventDefault();
                openChatBlock(e.target);
            }
            if (openSignUp) {
                onChatToMeClick(university, student, e.target);
            }
        },
        [account, university, student, onChatToMeClick, fromChatToUs, randomPage]
    );

    const onProfileClick = useCallback(() => {
        let query = window.location.href.split('?')[1] ? window.location.href.split('?')[1] : '';
        query = query.length ? '?' + query : '';
        navigate(`${getCommonRoutePath()}/chat-to-us/${getIndividualNamePath(student.name, student.id)}/${query}`);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [navigate, student]); // TODO: Bug here, account is not in the dependencies

    const showMoreLess = useCallback(
        (e) => {
            e.preventDefault();
            e.stopPropagation();
            setShowFullText(!showFullText);
        },
        [showFullText]
    );

    const isOnline = student.last_activity
        ? dayjs().valueOf() <= dayjs(student.last_activity).valueOf() + 1000 * 60 * 5
        : false;
    const isMobile = IsMobile();
    const queryData = getQueryDataOnSignClick();

    const displayFlag = showFlag();

    const description = (student.description || '') + ' ';
    let avatar = null;
    let subject = null;
    let courses = null;
    let year = null;
    let job = null;
    let role = null;
    let jobTitle = null;

    let showTextLink = false;
    if (student.description) {
        if (showFullText) {
            showTextLink = true;
        } else {
            let totalNumber = 0;
            for (let i = 0; i < student.description.length; i++, totalNumber++) {
                if (student.description[i] === '\n') {
                    totalNumber += 25;
                } else if (student.description[i] === 's') {
                    totalNumber -= 1;
                }

                if (totalNumber > 75) {
                    showTextLink = true;
                    break;
                }
            }
        }
    }

    const universityAvatar =
        university && university.avatar && university.avatar.original
            ? university.avatar.sizes['160x160'] || university.avatar.original
            : universityDefaultAvatar;

    if (!student.avatar) {
        avatar = student.isUniversity ? universityAvatar : userDefaultAvatar;
    } else {
        if (!student.avatar.sizes['160x160']) {
            avatar = student.avatar.original;
        } else {
            avatar = student.avatar.sizes['160x160'];
        }
    }

    if (student.user_tags.profile && student.user_tags.profile[0]) {
        role = student.user_tags.profile[0].name;
    }

    if (!student.user_tags) {
        subject = null;
    } else {
        if (!student.user_tags.subject) {
            subject = null;
        } else {
            subject = student.user_tags.subject[0].name;
        }
    }

    if (!student.user_tags) {
        courses = null;
    } else {
        if (!student.user_tags.courses_types) {
            courses = null;
        } else {
            courses = student.user_tags.courses_types[0].name;
        }
    }

    if (!student.user_tags) {
        jobTitle = null;
    } else {
        if (!student.user_tags.job_title) {
            jobTitle = null;
        } else {
            jobTitle = student.user_tags.job_title[0].name;
        }
    }

    if (student.user_tags) {
        if (student.user_tags.job_role) {
            job = student.user_tags.job_role[0].name;
        }
    }

    if (!student.user_tags) {
        year = null;
    } else if (student.user_tags.student) {
        year = getStudentYear(student.user_tags);
        if (!year) {
            year = null;
        } else {
            year = year.name;
        }
    }

    const countryIcon =
        student.user_tags && student.user_tags.countries && displayFlag
            ? student.user_tags.countries[0].code === 'GB-CHA'
                ? 'GB'
                : student.user_tags.countries[0].code
            : null;
    const country = student.user_tags && student.user_tags.countries ? student.user_tags.countries[0].name : null;
    const region = student.region ? student.region : '';
    const showActivity = dayjs(student.last_activity).valueOf() + 3 * 24 * 60 * 60 * 1000 >= dayjs().valueOf();

    const lastActivePlusThree = dayjs(student.last_activity).add(3, 'days');
    const currentDate = dayjs();
    const isActiveRecently = lastActivePlusThree > currentDate;

    const chatPermission = student.permissions ? student.permissions.filter(({ name }) => name === 'Chat') : [];

    return (
        <List.Item
            className={
                'profile-card' +
                (groupUniversityId ? ' profile-card-group' : '') +
                (isMobile ? ' profile-card-mobile' : '')
            }
        >
            <div
                onClick={() => onProfileClick()}
                className={
                    'profile-card-wrapper-v2 profile-card-wrapper-v2-2 ' +
                    (showFullText ? 'full-text-active' : 'short-text-active')
                }
                id={`profile-card-${student.id}`}
            >
                <div className="university-profile-header">
                    {groupUniversityId && (
                        <div className="university-profile-page-header uni-avatar-block">
                            <div className="img-wrapper">
                                <Image
                                    src={
                                        university && university.avatar && university.avatar.original
                                            ? university.avatar.sizes['160x160'] || university.avatar.original
                                            : universityDefaultAvatar
                                    }
                                    onError={(e) => {
                                        e.target.onerror = null;
                                        e.target.src = universityDefaultAvatar;
                                    }}
                                    alt=""
                                />
                            </div>
                            <div className="university-header-text">
                                <Popover
                                    placement="bottomLeft"
                                    content={<div>{university.name}</div>}
                                    onClick={(e) => e.preventDefault()}
                                >
                                    <span className="university-name">{university.name}</span>
                                </Popover>
                            </div>
                        </div>
                    )}
                </div>
                {(isOnline || (isActiveRecently && showActivity && !isMobile) || groupUniversityId) && (
                    <p className="ambassador-profile-border-top" />
                )}
                {/* {isMobile && (
                        <span className="chat-online">
                            {
                                isOnline
                                    ? <div className="profile-status">
                                        <span className="profile-status__dot" />
                                        <span className="profile-status__name" children="Online" />
                                    </div>
                                    : isActiveRecently
                                        ? (showActivity
                                            ? <span>Last online {DateHumanizeHelper(student.last_activity ? student.last_activity : student.created_at)}</span>
                                            : null)
                                        : null
                            }
                        </span>
                    )} */}
                <div className={'ambassador-profile-v2' + (isMobile ? ' ambassador-profile-mobile-v2' : '')}>
                    <div className="profile-view">
                        <div className="chat-img-container-v2">
                            <div className="chat-img-block-v2">
                                <Image
                                    className="chat-img"
                                    src={avatar || userDefaultAvatar}
                                    onError={(e) => {
                                        e.target.onerror = null;
                                        e.target.src = userDefaultAvatar;
                                    }}
                                    alt={student.name + "'s avatar'"}
                                />
                            </div>
                        </div>
                    </div>
                    <div className="profile-info">
                        <div className="profile-info-header">
                            <div className="profile-info-header-student">
                                <h2
                                    className={
                                        'profile-view-name' +
                                        (student.name.length > 13 ? ' profile-view__short-name' : '')
                                    }
                                >
                                    {student.name}
                                </h2>

                                <span className="chat-online">
                                    {isOnline ? (
                                        <div className="profile-status">
                                            <span className="profile-status__dot" />
                                            <span className="profile-status-name-v2">Online</span>
                                        </div>
                                    ) : isActiveRecently ? (
                                        showActivity ? (
                                            <span>
                                                Last online{' '}
                                                {DateHumanizeHelper(
                                                    student.last_activity ? student.last_activity : student.created_at
                                                )}
                                            </span>
                                        ) : null
                                    ) : null}
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
                {(country || region || countryIcon) && (
                    <div className="flag-student-block">
                        {countryIcon && <span className={'flag-icon flag-icon-' + countryIcon.toLowerCase()} />}
                        {region && (
                            <span className="place-tag-v2" onClick={(e) => handleSearch(e, region)}>
                                {region}
                            </span>
                        )}
                        {region && country ? ',' : ''}
                        {country && (
                            <span className="place-tag-v2" onClick={(e) => handleSearch(e, country)}>{`${
                                country || ''
                            }`}</span>
                        )}
                    </div>
                )}

                {(courses || subject || jobTitle || job) && (
                    <div>
                        {courses && (
                            <>
                                <div className="text-description-title-v2">Course</div>
                                <span
                                    className="student-common-info-block-v2"
                                    onClick={(e) => handleSearch(e, courses)}
                                >
                                    {courses}
                                </span>
                            </>
                        )}
                        {courses && (subject || jobTitle || job) ? ', ' : ''}
                        {subject && (
                            <span className="student-common-info-block-v2" onClick={(e) => handleSearch(e, subject)}>
                                {subject + (jobTitle || job ? ', ' : '')}
                            </span>
                        )}
                        {subject && (jobTitle || job) ? ', ' : ''}
                        {jobTitle && (
                            <span className="student-common-info-block-v2" onClick={(e) => handleSearch(e, jobTitle)}>
                                {jobTitle + (job ? ', ' : '')}
                            </span>
                        )}
                        {jobTitle && job ? ', ' : ''}
                        {job && (
                            <span className="student-common-info-block-v2" onClick={(e) => handleSearch(e, job)}>
                                {job}
                            </span>
                        )}
                    </div>
                )}

                <div
                    className={
                        'text-description-block-v2' +
                        (!courses && !subject && !jobTitle && !job && !countryIcon && !region && !country
                            ? ' mt-0'
                            : '')
                    }
                >
                    <div className="text-description-title-v2">Bio</div>
                    <div className="text-description-v2">{description}</div>
                    {showTextLink && (
                        <span className={showFullText ? 'see-less-button' : 'see-more-button'} onClick={showMoreLess}>
                            {showFullText ? '...see less' : '...see more'}
                        </span>
                    )}
                </div>
                {student.user_tags && student.user_tags.interests && student.user_tags.interests.length > 0 ? (
                    <div className="profile-info-tags-v2">
                        <span className="profile-info-tags-header-v2">
                            {role === 'Staff' ? 'Interests' : 'Interests and hobbies'}
                        </span>
                        <div className="profile-info-tags-container-v2">
                            {student.user_tags.interests.map((tag) => (
                                <span
                                    key={tag.id}
                                    className="profile-info-tags-tag-v2"
                                    onClick={(e) => handleSearch(e, tag.name)}
                                >
                                    {tag.name}
                                </span>
                            ))}
                        </div>
                    </div>
                ) : null}
                <p className="profile-view-chat-link-button-space" />
                {(chatPermission.length ? chatPermission[0].is_enabled : false) && (
                    <>
                        {!IsLoggedIn(account) && !isMobile ? (
                            <Button
                                className="profile-view-chat-link-button v2"
                                onClick={(e) => handleChatToMeClick(e, true)}
                                aria-label={`Start a conversation with ${student.name}`}
                            >
                                <span className="profile-view-chat-link-button-text">Ask me a question</span>
                                <MessagesIcon />
                            </Button>
                        ) : (
                            <NavLink
                                end
                                to={getCommonRoutePath() + '/interaction/' + +student.id + queryData}
                                className="profile-view-chat-link-button v2"
                                id={`chat-link-${student.id}`}
                                onClick={handleChatToMeClick}
                                aria-label={`Start a conversation with ${student.name}`}
                                target={isMobile ? '_blank' : '_self'}
                            >
                                <span className="profile-view-chat-link-button-text">Ask me a question</span>
                                <MessagesIcon />
                            </NavLink>
                        )}
                    </>
                )}
            </div>
        </List.Item>
    );
};

export default TapPageStudentItemV2;
